<h2 class="alert alert-danger" *ngIf="error">
  {{ error }} Kayıt ve internet durumunuzu kontrol ediniz.
</h2>
<h1>{{ record }}</h1>
<br />
<br />
<button class="excel-button" (click)="exportexcel()">
  Patent Portföy Raporunu İndir (Excel)
</button>
<br>
<table>
  <tr>



    <td>

        <h5 style="margin-left: 2%">Patent Türü:</h5>
        <select
          name="searchPatentType"
          [(ngModel)]="searchPatentType"
          id="countryName"
        >
        <option value="">

        </option>
        <option value="incelemeli patent">İncelemeli Patent

      </option>
        <option value="incelemesiz patent">İncelemesiz patent

      </option>
      <option value="faydalı model (araştırma raporsuz)">Faydalı Model (araştırma raporsuz)
    </option>
          <option value="faydalı model (araştırma raporlu)">Faydalı Model (araştırma raporlu)
        </option>


        </select>

      <h5 style="margin-left: 2%">Patent Ülkesi:</h5>

      <select
      name="searchPatentCountry"
      [(ngModel)]="searchPatentCountry"
      id="countryName"
        >
        <option value=""></option>
          <option value="türkiye (tr)">Türkiye (TR)</option>
          <option value="pct (wipo)(pct)">PCT (WIPO)(PCT)</option>
          <option value="avrupa (epo)(ep)">Avrupa Patenti (EPO)(EP)</option>
          <option value="körfez işbirliği sözleşmesi (gcc)">
            Körfez İşbirliği Sözleşmesi (GCC)
          </option>
          <option value="avrasya patent sözleşmesi (eurasian)">
            Avrasya Patent Sözleşmesi (EURASIAN)
          </option>
          <option value="afrika fikri mülkiyet örgütü (oapi)">
            Afrika Fikri Mülkiyet Örgütü (OAPI)
          </option>
          <option value="afrika fikri mülkiyet örgütü (aripo)">
            Afrika Fikri Mülkiyet Örgütü (ARIPO)
          </option>
          <option value="amerika (us)">Amerika (US)</option>
          <option value="birleşik arap emirlikleri (bae)">
            Birleşik Arap Emirikleri (BAE)
          </option>
          <option value="antigua ve barbuda (ag)">
            Antigua ve Barbuda (AG)
          </option>
          <option value="arnavutluk (al)">Arnavutluk (AL)</option>
          <option value="ermenistan (am)">Ermenistan (AM)</option>
          <option value="angola (ao)">Angola (AO)</option>
          <option value="avusturya (at)">Avusturya (AT)</option>
          <option value="azerbeycan/azerbaycan (az)">Azerbeycan (AZ)</option>
          <option value="saraybosna/bosnahersek (ba)">SarayBosna (BA)</option>
          <option value="barbados (bb)">Barbados (BB)</option>
          <option value="belçika (be)">Belçika (BE)</option>
          <option value="burkina faso (BF)">Burkina Faso (BF)</option>
          <option value="bulgaristan (bg)">Bulgaristan (BG)</option>
          <option value="bahreyn (be)">Bahreyn (BE)</option>
          <option value="benin (bj)">Benin (BJ)</option>
          <option value="brezilya (br)">Brezilya (BR)</option>
          <option value="botsvana/botswana (bw)">Botsvana (BW)</option>
          <option value="belarus (by)">Belarus (BY)</option>
          <option value="belize (bz)">Belize (BZ)</option>
          <option value="kanada (ca)">Kanada (CA)</option>
          <option value="orta afrika cumhuriyeti (cf)">
            Orta Afrika Cumhuriyeti (CF)
          </option>
          <option value="isviçre (ch)">İsviçre (CH)</option>
          <option value="fildişi sahili (ci)">Fildişi Sahili (CI)</option>
          <option value="şili (cl)">Şili (CL)</option>
          <option value="kamerun (CM)">Kamerun (CM)</option>
          <option value="çin (cn)">Çin (CN)</option>
          <option value="kolombiya (co)">Kolombiya (CO)</option>
          <option value="kosta rika/kostarika (cr)">Kosta Rika (CR)</option>
          <option value="küba (cu)">Küba (CU)</option>
          <option value="kıbrıs (cy)">Kıbrıs (CY)</option>
          <option value="çek cumhuriyeti (cz)">Çek Cumhuriyeti (CZ)</option>
          <option value="almanya (de)">Almanya (DE)</option>
          <option value="cibuti (dj)">Cibuti (DJ)</option>
          <option value="danimarka (da)">Danimarka (DA)</option>
          <option value="dominik (dm)">Dominik (DM)</option>
          <option value="dominik cumhuriyeti (do)">
            Dominik Cumhuriyeti (DO)
          </option>
          <option value="cezayir (dz)">Cezayir (DZ)</option>
          <option value="ekvator (ec)">Ekvator (EC)</option>
          <option value="estonya (ee)">Estonya (EE)</option>
          <option value="mısır (eg)">Mısır (EG)</option>
          <option value="ispanya (es)">İspanya (ES)</option>
          <option value="finlandiya (fi)">Finlandiya (FI)</option>
          <option value="fransa (fr)">Fransa (FR)</option>
          <option value="gabon (ga)">Gabon (GA)</option>
          <option value="ingiltere krallığı (gb)">İngiltere (GB)</option>
          <option value="grenada (gd)">Grenada (GD)</option>
          <option value="Gürcistan (ge)">Gürcistan (GE)</option>
          <option value="gana (gh)">Gana (GH)</option>
          <option value="gambiya (gm)">Gambiya (GM)</option>
          <option value="gine (gn)">Gine (GN)</option>
          <option value="yunanistan (gr)">Yunanistan (GR)</option>
          <option value="guatemala (gn)">Guatemala (GN)</option>
          <option value="honduras (hn)">Honduras (HN)</option>
          <option value="hırvatistan (hr)">Hırvatistan (HR)</option>
          <option value="macaristan (hu)">Macaristan (hu)</option>
          <option value="endonezya (id)">Endonezya (ID)</option>
          <option value="irlanda (ie)">İrlanda (IE)</option>
          <option value="israil (il)">İsrail (IL)</option>
          <option value="hindistan (ie)">Hindistan (IE)</option>
          <option value="ırak (iq)">Irak (IQ)</option>
          <option value="iran (ir)">İran (IR)</option>
          <option value="izlanda (is)">İzlanda (IS)</option>
          <option value="italya (it)">İtalya (IT)</option>
          <option value="jamaika (jm)">Jamaika (JM)</option>
          <option value="ürdün (jo)">Ürdün (JO)</option>
          <option value="japonya (jp)">Japonya (JP)</option>
          <option value="kenya (ke)">Kenya (KE)</option>
          <option value="kırgizistan (kg)">Kırgızistan (KG)</option>
          <option value="kamboçya (kh)">Kamboçya (KH)</option>
          <option value="güney kore (kr)">Güney Kore (KR)</option>
          <option value="kuveyt (kw)">Kuveyt (KW)</option>
          <option value="kazakistan (kz)">Kazakistan (KZ)</option>
          <option value="lübnan (lb)">Lübnan (LB)</option>
          <option value="lihtenştayn (li)">Lihtenştayn (LI)</option>
          <option value="sri lanka/srilanka (lr)">Sri Lanka (LR)</option>
          <option value="liberya (lr)">Liberya (LR)</option>
          <option value="lesotho (ls)">Lesotho (LS)</option>
          <option value="litvanya (lt)">Litvanya (LT)</option>
          <option value="lüksemburg (lu)">Lüksemburg (LU)</option>
          <option value="letonya (lv)">Letonya (LV)</option>
          <option value="libya (ly)">Libya (LY)</option>
          <option value="fas (ma)">Fas (MA)</option>
          <option value="monaco (mc)">Monaco (MC)</option>
          <option value="moldova (md)">Moldova (MD)</option>
          <option value="karadağ (me)">Karadağ (ME)</option>
          <option value="madagaskar (md)">Madagaskar (MD)</option>
          <option value="makedonya (mk)">Makedonya (MK)</option>
          <option value="mali (me)">Mali (ME)</option>
          <option value="moğolistan (mn)">Moğolistan (MN)</option>
          <option value="moritanya (mr)">Moritanya (MR)</option>
          <option value="malta (mt)">Malta (MT)</option>
          <option value="meksika (mx)">Meksika (MX)</option>
          <option value="malezya (me)">Malezya (ME)</option>
          <option value="mozambik (mz)">Mozambik (MZ)</option>
          <option value="namibya (na)">Namibya (NA)</option>
          <option value="nijer (ne)">Nijer (NE)</option>
          <option value="nijerya (ng)">Nijerya (NG)</option>
          <option value="nikeragua (ni)">Nikeragua (NI)</option>
          <option value="hollanda (nl)">Hollanda (NL)</option>
          <option value="norveç (no)">Norveç (NO)</option>
          <option value="yeni zelanda (nz)">Yeni Zelanda (NZ)</option>
          <option value="umman (om)">Umman (OM)</option>
          <option value="panama (pa)">Panama (PA)</option>
          <option value="peru (pe)">Peru (PE)</option>
          <option value="papua yeni gine (pg)">Papua Yeni Gine (PG)</option>
          <option value="filipinler (PH)">Filipinler (PH)</option>
          <option value="polonya (pl)">Polonya (PL)</option>
          <option value="portekiz (pt)">Portekiz (PT)</option>
          <option value="katar (qa)">Katar (QA)</option>
          <option value="romanya (ro)">Romanya (RO)</option>
          <option value="sırbistan (rs)">Sırbistan (RS)</option>
          <option value="rusya (ru)">Rusya (RU)</option>
          <option value="suudi arabistan (sa)">Suudi Arabistan (SA)</option>
          <option value="sudan (sd)">Sudan (SD)</option>
          <option value="isveç (se)">İsveç (SE)</option>
          <option value="singapur (sg)">Singapur (SG)</option>
          <option value="slovenya (si)">Slovenya (SI)</option>
          <option value="slovakya (sk)">Slovakya (SK)</option>
          <option value="san marino (sm)">San Marino (SM)</option>
          <option value="senegal (sn)">Senegal (SN)</option>
          <option value="el salvador/elsalvador (sv)">El Salvador (SV)</option>
          <option value="suriye (sy)">Suriye (SY)</option>
          <option value="çad (td)">Çad (TD)</option>
          <option value="togo (tg)">Togo (TG)</option>
          <option value="tayland (th)">Tayland (TH)</option>
          <option value="tacikistan (tj)">Tacikistan (TJ)</option>
          <option value="türkmenistan (tm)">Türkmenistan (TM)</option>
          <option value="tunus (tn)">Tunus (TN)</option>
          <option value="trinidad ve tobago (tt)">
            Trinidad ve Tobago (TT)
          </option>
          <option value="tanzanya (tz)">Tanzanya (TZ)</option>
          <option value="ukrayna (ua)">Ukrayna (UA)</option>
          <option value="angola (ao)">Uganda (UG)</option>
          <option value="amerika (us)">Amerika (US)</option>
          <option value="özbekistan (uz)">Özbekistan (UZ)</option>
          <option value="vietnam (vn)">Vietnam (VN)</option>
          <option value="güney afrika (za)">Güney Afrika (ZA)</option>
          <option value="zambiya (zm)">Zambiya (ZM)</option>
          <option value="zimbabve (zw)">Zimbabve (ZW)</option>
        </select>
        <input  style="margin-left: 0.5%" [(ngModel)]="applicationNo" (ngModelChange)="applicationNo=$event.toLowerCase()" placeholder="Başvuru Numarası" />
        <input style="margin-left: 0.5%" [(ngModel)]="publicationNo" (ngModelChange)="publicationNo= $event.toLowerCase()"placeholder="Yayın Numarası" />
      </td>

        <td>
          <label style="margin-left: 2%">Patent Süreç Sorgula:</label>

          <select
            name="searchPatentType"
            [(ngModel)]="searchPatStatus"
            id="countryName"
          >
          <option value="">

          </option>
          <option value="başvuru">Başvuru

        </option>
        <option value="şekli eksiklik">Şekli Eksiklik

        </option>
        <option value="şekli uygunluk">Şekli Uygunluk

        </option>
        <option value="resmi araştırma talep">Resmi Araştırma Talep

        </option>
        <option value="resmi araştırma rapor">Resmi Araştırma Rapor

        </option>

        <option value="resmi inceleme talep">Resmi İnceleme Talep

        </option>
        <option value="resmi inceleme rapor">Resmi İnceleme Rapor

        </option>
        <option value="yayın">Yayın

        </option>
        <option value="iptal">İptal

        </option>
        <option value="tescil">Tescil

        </option>
        <option value="belge kararı">Belge Kararı

        </option>
        <option value="belge düzenleme">Belge Düzenleme

        </option>
        <option value="kullanma bildirimi">Kullanma Bildirimi

        </option>



          </select>
          <h6>Başlangıç</h6>
          <input

            style="color: black; background-color: white;"
            class="form-control"
            class="icon"
            type="date"
            name="search"
            [(ngModel)]="patAppStartDate"
            autocomplete="off"

          />

          <h6>Bitiş </h6>
          <input

            style="color: black;background-color: white;"
            class="form-control"
            class="icon"
            type="date"
            name="search"
            [(ngModel)]="patAppEndDate"

            autocomplete="off"

          />

            </td>
    <td>
      <label style="margin-left: 2%">Buluş Hak Talebi Durumu:</label>
      <select
      name="searchInvRight"
      [(ngModel)]="searchInvRight"
      id="countryName"
    >
    <option value="">

    </option>
    <option value="taslak buluş">"Taslak Buluş"

  </option>
  <option value="kabul edilmiş buluş">"Kabul Edilmiş Buluş"

  </option>
  <option value="karar:buluş iptal edildi">"karar:Buluş iptal edildi"

  </option>
  <option value="karar:buluş hakları buluş sahibine verildi">"karar:Buluş hakları buluş sahibine verildi."

  </option>
  <option value="karar:buluş gizli tutulacaktır">"karar:Buluş gizli tutulacaktır."

  </option>
  <option value="karar:buluş iptal edildi">"karar:Buluş iptal edildi"

  </option>
  <option value="karar:buluş hakları şirkete verildi">"karar:Buluş hakları ŞİRKETE verildi"

  </option>


  </select>


    <h6>Başlangıç</h6>
    <input

    style="color: black; background-color: white;"
    class="form-control"
    class="icon"
    type="date"
    name="search"
      [(ngModel)]="invDecStartDate"
      autocomplete="off"

    />

    <h6>Bitiş</h6>
    <input

    style="color: black; background-color: white;"
    class="form-control"
    class="icon"
    type="date"
    name="search"
      [(ngModel)]="invDecEndDate"
      autocomplete="off"

    />
    </td>


  <td><h5 style="margin-left: 2%">Buluşçu:</h5>

    <input

      style="color: black;background-color: white;"
      class="form-control"
      class="icon"
      type="text"
      name="search"
      [(ngModel)]="searchInventorName"
      (ngModelChange)="searchInventorName=$event.toLowerCase()"
      autocomplete="off"
      placeholder="Buluşçu Adı Üzerinden Arama Yapabilirsiniz"
    />
    <ng-container *ngIf="!hideAttorney">
  <h5 style="margin-left: 2%">Vekil:</h5>

  <input

    style="color: black;background-color: white;"
    class="form-control"
    class="icon"
    type="text"
    name="search"
    [(ngModel)]="searchAttorneyName"
    (ngModelChange)="searchAttorneyName=$event.toLowerCase()"
    autocomplete="off"
    placeholder="Vekil Adı Üzerinden Arama Yapabilirsiniz"
  />
</ng-container>
  <h5 style="margin-left: 2%">Hak Sahibi:</h5>

  <input

    style="color: black;background-color: white;"
    class="form-control"
    class="icon"
    type="text"
    name="search"
    [(ngModel)]="searchCompanyName"
    (ngModelChange)="searchCompanyName=$event.toLowerCase()"
    autocomplete="off"
    placeholder="Hak Sahibi Üzerinden Arama Yapabilirsiniz"
  />
  </td>
</tr>

</table>
<button style="text-align: center;margin: auto ;display: flex;margin-top: 2%;margin-bottom: 1%;" (click)="submit()">Belirlenen Kriterler Üzerinden Ara</button>
<table style="margin-bottom: 1%;" *ngIf="!visible">
  <tr>
    <td>
      <input type="checkbox" [(ngModel)]="visDoc" value="False" />
      <h6>Dosya No.</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visInvName" value="False" />
      <h6>Buluş Adı</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visInvDate" value="False" />
      <h6>Buluş Bildirim Tarihi</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visStatus" value="False" />
      <h6>Buluşun Durumu</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visAttorney" value="False" />
      <h6>Patent Vekili</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visTRStatus" value="False" />
      <h6>Türkiye Son Durum</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visTRApp" value="False" />
      <h6>Türkiye Başvuru Tarihi</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visTRReg" value="False" />
      <h6>Türkiye Tescil Tarihi</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visLastUpdate" value="False" />
      <h6>En Son Güncelleme Tarihi</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visOwner" value="False" />
      <h6>Hak Sahibi</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visInventor" value="False" />
      <h6>Buluş Sahipleri</h6>
    </td>
    <td>
      <input type="checkbox" [(ngModel)]="visPatentRec" value="False" />
      <h6>Patent Kayıtları</h6>
    </td>
  </tr>
</table>
<br />
<table id="excel-table" class="tableFixHead">
  <thead>
    <tr>
      <th>#</th>
      <th *ngIf="checkVisDoc()">Dosya No</th>
      <th *ngIf="checkVisInvName()">Buluş Adı</th>
      <th *ngIf="checkVisInvDate()">Buluş Bildirim Tarihi</th>
      <th *ngIf="checkVisStatus()">Buluşun Durumu</th>
      <th *ngIf="checkVisAttorney()">Patent Vekili</th>
      <th *ngIf="checkVisTRStatus()">Türkiye Son Durum</th>
      <th *ngIf="checkVisTRApp()">Türkiye Başvuru Tarihi</th>
      <th *ngIf="checkVisTRReg()">Türkiye Tescil Tarihi</th>
      <th *ngIf="checkVisLastUpdate()">Son Durum Güncellemesi</th>
      <th *ngIf="checkvisOwner()">Hak Sahipliği Durumu</th>
      <th *ngIf="checkvisInventor()">Buluş Sahipleri</th>
      <th *ngIf="checkvisPatentRec()">Patent Kayıtları</th>
      <th *ngIf="!switch"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let user of result | filter: searchText; let i = index">
       <ng-container *ngIf="users1.includes(user)">
        <ng-container *ngFor="let item of user">
          <td
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            {{ i + 1 }}
          </td>
          <td
            *ngIf="checkVisDoc()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            {{ item.documentNumber }}
          </td>
          <td
            *ngIf="checkVisInvName()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            {{ item.inventionName }}
          </td>
          <td
            *ngIf="checkVisInvDate()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            {{ item.inventionDate | date: "dd/MM/yyyy" }}
          </td>
          <!-- <td>{{ item.status[item.status.length - 1].status }}</td> -->

          <td
            *ngIf="checkVisStatus()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            {{ item.status.status }}
          </td>
          <td
            *ngIf="checkVisAttorney()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            <ng-container *ngFor="let subitem of item.AttorneyData">
              {{ subitem.name }}</ng-container
            >
          </td>
          <td
            *ngIf="checkVisTRStatus()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            <ng-container *ngFor="let subitem of item.patentInfo">
              {{
                subitem.patentCountry.includes("türkiye") &&
                (subitem.patentStatus.slice(-1)[0].status.includes("tescil") ||
                  subitem.patentStatus.slice(-1)[0].status.includes("başvuru"))
                  ? (subitem.patentStatus.slice(-1)[0].status[0] )
                  : null
              }}
              {{
                subitem.patentCountry.includes("türkiye") &&
                !(
                  subitem.patentStatus.slice(-1)[0].status.includes("tescil") ||
                  subitem.patentStatus.slice(-1)[0].status.includes("başvuru")
                )
                  ? (subitem.patentStatus.slice(-1)[0].status)
                  : null
              }}
            </ng-container>
          </td>
          <td
            *ngIf="checkVisTRApp()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            <ng-container *ngFor="let subitem of item.patentInfo">
              {{
                subitem.patentCountry.includes("türkiye") &&
                subitem.patentStatus[0].status.includes("başvuru")
                  ? (subitem.patentStatus[0].status[1] | date: "dd/MM/yyyy")
                  : null
              }}</ng-container
            >
          </td>
          <td
            *ngIf="checkVisTRReg()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            <ng-container *ngFor="let subitem of item.patentInfo">
              {{
                subitem.patentCountry.includes("türkiye") &&
                subitem.patentStatus.slice(-1)[0].status.includes("tescil")
                  ? (subitem.patentStatus.slice(-1)[0].status[1]
                    | date: "dd/MM/yyyy")
                  : null
              }}</ng-container
            >
          </td>

          <td
            *ngIf="checkVisLastUpdate()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            {{ item.status.date | DayAgo }}
          </td>
          <!-- [style.background-color]="
            today - paintRows[i] > oneDay / 2 ? 'red' : 'green'
          " -->
          <!-- <button id="remove" class="btn btn-danger" (click)="removeInvention(i)">
          Remove Invention
        </button> -->
          <td
            *ngIf="checkvisOwner()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            <ng-container *ngFor="let subitem of item.CompanyData">
              <hr />
              <ng-container
                >{{ subitem.name }}/Katkı Payı:{{ subitem.share }}
                <p></p
              ></ng-container>
              <hr />
            </ng-container>
          </td>
          <td
            *ngIf="checkvisInventor()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            <ng-container *ngFor="let subitem of item.inventorData">
              <hr />
              <ng-container
                >{{ subitem.name }}/Katkı Payı:{{ subitem.share }}
                <p></p
              ></ng-container>
              <hr />
            </ng-container>
          </td>
          <td
            *ngIf="checkvisPatentRec()"
            [style.color]="
              item.status.status === 'karar:buluş iptal edildi.' ? 'red' : ''
            "
          >
            <ng-container *ngFor="let subitem of item.patentInfo">
              <hr />
              <ng-container
                >Ülke:{{
                  subitem.patentCountry
                }}/Tür:{{ subitem.patentType }}/Durum:{{
                  subitem.patentStatus
                    .slice(-1)[0]
                    .status.includes("Süreç Devam Ediyor") ||
                    subitem.patentStatus.slice(-1)[0]
                    .status.includes("süreç devam ediyor") ||
                  subitem.patentStatus.slice(-1)[0].status.includes("İptal") ||
                  subitem.patentStatus.slice(-1)[0].status.includes("iptal")
                    ? subitem.patentStatus.slice(-1)[0].status
                    : subitem.patentStatus.slice(-1)[0].status[0] +
                      "-" +
                      (subitem.patentStatus.slice(-1)[0].status[1]
                        | date: "dd/MM/yyyy")
                }}
                <p></p
              ></ng-container>
              <hr />
            </ng-container>
          </td>
          <td *ngIf="!switch" style="background-color: #f8f9fb">
            <button
              id="remove"
              class="btn"
              (click)="inventionDetails(i, item.documentNumber)"
            >
              Buluş Detayları
            </button>
          </td>
        </ng-container>
    </ng-container>
    </tr>
  </tbody>
</table>

<br />
<!-- <button class="btn btn-primary" (click)="fetchUsers()">Veriyi Getir</button> -->
